import React, { Component } from "react";
import PropTypes from "prop-types";
import Countdown from "react-countdown-now";
import OnAir from "./onAir";
import { VideoPropTypes } from "../../constants/classPropTypes";
import "./upcoming.scss";

class Upcoming extends Component {
  renderer = ({ days, hours, minutes, seconds, completed }) => {
    const { video, source } = this.props;
    const scheduleTime = new Date(video.scheduledStartTime).toLocaleString();

    const upcomingBlock = (
      <div className="d-flex flex-wrap align-items-center justify-content-evenly">
        <div>
          <h2>
            Next {video.category} Live {source}
          </h2>
          <h3>
            Topic: {video?.displayTitle ? video.displayTitle : video.title}
          </h3>
          <hr />
          <div className="video-countdown">
            <p>{scheduleTime}</p>
            <p>
              {days}d {hours}h {minutes}m {seconds}s
            </p>
          </div>
          <div className="video-img header-video">
            <a
              href={video.url}
              target="_blank"
              rel="noopener noreferrer"
              title={video?.displayTitle ? video.displayTitle : video.title}
            >
              <div className="thumbnail-wrapper">
                <img
                  src={video.thumbnailUrl}
                  role="presentation"
                  alt=""
                  className="img-fluid"
                />
              </div>
            </a>
          </div>
        </div>
      </div>
    );

    return completed ? <OnAir video={video} /> : upcomingBlock;
  };

  render() {
    const { video } = this.props;
    const scheduleTimeInMillisecond = Date.parse(video.scheduledStartTime);
    return (
      <Countdown date={scheduleTimeInMillisecond} renderer={this.renderer} />
    );
  }
}

Upcoming.propTypes = {
  video: VideoPropTypes.isRequired,
  source: PropTypes.string.isRequired,
};

export default Upcoming;
